import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

type ExistingDocumentsWithNumberResponse = {
    count: number;
};

export class ExistingDocumentsWithNumberQuery extends Query<number| null> {
    public constructor(public readonly documentNumber: string) {
        super();
    }
}

export class ExistingDocumentsWithNumberQueryHandlerBase implements QueryHandler<ExistingDocumentsWithNumberQuery, number | null> {
    private static Url = TaggedUrl.join('documents/numberings', [Tags.Api, Tags.NotHandle404]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: ExistingDocumentsWithNumberQuery): Promise<number | null> {
        try {
            const { data } = await this.http.get<ExistingDocumentsWithNumberResponse>(ExistingDocumentsWithNumberQueryHandlerBase.Url, {
                params: {
                    documentNumber: encodeURI(query.documentNumber)
                }
            });
            return data.count;
        } catch (error) {
            return null;
        }
    }
}
